import { FormFeedback } from "reactstrap";
import styled from "styled-components";

export default styled(FormFeedback)`
  display: block;
`;
